export const actions = {
  PRODUCTOS_LOAD_REQUESTED: 'PRODUCTOS_LOAD_REQUESTED',
  PRODUCTOS_LOAD_FILTERED_REQUESTED: 'PRODUCTOS_LOAD_FILTERED_REQUESTED',
  PRODUCTOS_LOAD_SUCCEEDED: 'PRODUCTOS_LOAD_SUCCEEDED',
  PRODUCTOS_LOAD_FILED: 'PRODUCTOS_LOAD_FILED',

  PRODUCTOS_ADICIONALES_LOAD_REQUESTED: 'PRODUCTOS_ADICIONALES_LOAD_REQUESTED',
  PRODUCTOS_ADICIONALES_LOAD_SUCCEEDED: 'PRODUCTOS_ADICIONALES_LOAD_SUCCEEDED',
  PRODUCTOS_ADICIONALES_LOAD_FILED: 'PRODUCTOS_ADICIONALES_LOAD_FILED',

  PRODUCTOS_ADICIONALES_BY_PRODUCTO_ID_LOAD_REQUESTED:
    'PRODUCTOS_ADICIONALES_BY_PRODUCTO_ID_LOAD_REQUESTED',
  PRODUCTOS_ADICIONALES_BY_PRODUCTO_ID_LOAD_SUCCEEDED:
    'PRODUCTOS_ADICIONALES_BY_PRODUCTO_ID_LOAD_SUCCEEDED',
  PRODUCTOS_ADICIONALES_BY_PRODUCTO_ID_LOAD_FILED:
    'PRODUCTOS_ADICIONALES_BY_PRODUCTO_ID_LOAD_FILED',

  PRODUCTO_BYID_LOAD_REQUESTED: 'PRODUCTO_BYID_LOAD_REQUESTED',
  PRODUCTO_BYID_LOAD_SUCCEEDED: 'PRODUCTO_BYID_LOAD_SUCCEEDED',
  PRODUCTO_BYID_LOAD_FILED: 'PRODUCTO_BYID_LOAD_FILED',

  PRODUCTOS_BYID_LOAD_REQUESTED: 'PRODUCTOS_BYID_LOAD_REQUESTED',
  PRODUCTOS_BYID_LOAD_SUCCEEDED: 'PRODUCTOS_BYID_LOAD_SUCCEEDED',
  PRODUCTOS_BYID_LOAD_FILED: 'PRODUCTOS_BYID_LOAD_FILED',

  PRODUCTO_BYID_LOAD_INSERT_REQUESTED: 'PRODUCTO_BYID_LOAD_INSERT_REQUESTED',
  PRODUCTO_BYID_LOAD_INSERT_SUCCEEDED: 'PRODUCTO_BYID_LOAD_INSERT_SUCCEEDED',
  PRODUCTO_BYID_LOAD_INSERT_FILED: 'PRODUCTO_BYID_LOAD_INSERT_FILED',

  PRODUCTO_UPDATE_REQUESTED: 'PRODUCTO_UPDATE_REQUESTED',
  PRODUCTO_UPDATE_SUCCEEDED: 'PRODUCTO_UPDATE_SUCCEEDED',
  PRODUCTO_UPDATE_FILED: 'PRODUCTO_UPDATE_FILED',

  PRODUCTO_INSERT_REQUESTED: 'PRODUCTO_INSERT_REQUESTED',
  PRODUCTO_INSERT_SUCCEEDED: 'PRODUCTO_INSERT_SUCCEEDED',
  PRODUCTO_INSERT_FILED: 'PRODUCTO_INSERT_FILED',

  PRODUCTO_DELETE_REQUESTED: 'PRODUCTO_DELETE_REQUESTED',
  PRODUCTO_DELETE_SUCCEEDED: 'PRODUCTO_DELETE_SUCCEEDED',
  PRODUCTO_DELETE_FILED: 'PRODUCTO_DELETE_FILED',

  PRODUCTOS_DELETE_REQUESTED: 'PRODUCTOS_DELETE_REQUESTED',
  PRODUCTOS_DELETE_SUCCEEDED: 'PRODUCTOS_DELETE_SUCCEEDED',
  PRODUCTOS_DELETE_FILED: 'PRODUCTOS_DELETE_FILED',

  MAPAS_LOAD_REQUESTED: 'MAPAS_LOAD_REQUESTED',
  MAPAS_LOAD_SUCCEEDED: 'MAPAS_LOAD_SUCCEEDED',
  MAPAS_LOAD_FILED: 'MAPAS_LOAD_FILED',

  PRODUCTOS_ADICIONALES_UPDATE_REQUESTED: 'PRODUCTOS_ADICIONALES_UPDATE_REQUESTED',
  PRODUCTOS_ADICIONALES_UPDATE_SUCCEEDED: 'PRODUCTOS_ADICIONALES_UPDATE_SUCCEEDED',
  PRODUCTOS_ADICIONALES_UPDATE_FILED: 'PRODUCTOS_ADICIONALES_UPDATE_FILED',

  PRODUCTOS_ADICIONALES_DELETE_REQUESTED: 'PRODUCTOS_ADICIONALES_DELETE_REQUESTED',
  PRODUCTOS_ADICIONALES_DELETE_SUCCEEDED: 'PRODUCTOS_ADICIONALES_DELETE_SUCCEEDED',
  PRODUCTOS_ADICIONALES_DELETE_FILED: 'PRODUCTOS_ADICIONALES_DELETE_FILED',

  PRODUCTOS_AVATARES_LOAD_REQUESTED: 'PRODUCTOS_AVATARES_LOAD_REQUESTED',
  PRODUCTOS_AVATARES_LOAD_SUCCEEDED: 'PRODUCTOS_AVATARES_LOAD_SUCCEEDED',
  PRODUCTOS_AVATARES_LOAD_FAILED: 'PRODUCTOS_AVATARES_LOAD_FAILED',
}

export const getProductosAction = dispatch => {
  dispatch({
    type: actions.PRODUCTOS_LOAD_REQUESTED,
  })
}

export const getProductosFilteredAction = (dispatch, filter) => {
  dispatch({
    type: actions.PRODUCTOS_LOAD_FILTERED_REQUESTED,
    payload: filter,
  })
}

export const getMapasAction = dispatch => {
  dispatch({
    type: actions.MAPAS_LOAD_REQUESTED,
  })
}

export const getProductoCreateEditByIdAction = (dispatch, id) => {
  if (id) {
    dispatch({
      type: actions.PRODUCTO_BYID_LOAD_REQUESTED,
      payload: id,
    })
  } else {
    dispatch({
      type: actions.PRODUCTO_BYID_LOAD_INSERT_REQUESTED,
    })
  }
}

export const getProductosByIdAction = (dispatch, payload) => {
  if (payload) {
    dispatch({
      type: actions.PRODUCTOS_BYID_LOAD_REQUESTED,
      payload,
    })
  } else {
    dispatch({
      type: actions.PRODUCTOS_BYID_LOAD_REQUESTED,
    })
  }
}

export const onSubmitInsertProductoFormAction = (dispatch, formProducto) => {
  dispatch({
    type: actions.PRODUCTO_INSERT_REQUESTED,
    payload: formProducto,
  })
}

export const onSubmitUpdateProductoFormAction = (dispatch, formProducto) => {
  dispatch({
    type: actions.PRODUCTO_UPDATE_REQUESTED,
    payload: formProducto,
  })
}

export const deleteProductoAction = (dispatch, id) => {
  dispatch({
    type: actions.PRODUCTO_DELETE_REQUESTED,
    payload: id,
  })
}

export const deleteListProductoAction = (dispatch, ids) => {
  dispatch({
    type: actions.PRODUCTOS_DELETE_REQUESTED,
    payload: ids,
  })
}

export const getProductosAdicionalesAction = dispatch => {
  dispatch({
    type: actions.PRODUCTOS_ADICIONALES_LOAD_REQUESTED,
  })
}

export const getProductosAdicionalesByProductoId = (dispatch, productoId) => {
  dispatch({
    type: actions.PRODUCTOS_ADICIONALES_BY_PRODUCTO_ID_LOAD_REQUESTED,
    payload: productoId,
  })
}

export const onSubmitProductosAdicionalesUpdateFormAction = (
  dispatch,
  productosAdicionalesForm,
) => {
  dispatch({
    type: actions.PRODUCTOS_ADICIONALES_UPDATE_REQUESTED,
    payload: productosAdicionalesForm,
  })
}

export const onDeleteProductosAdicionalesAction = (dispatch, productoId) => {
  dispatch({
    type: actions.PRODUCTOS_ADICIONALES_DELETE_REQUESTED,
    payload: productoId,
  })
}

export const getProductosAvataresAction = dispatch => {
  dispatch({
    type: actions.PRODUCTOS_AVATARES_LOAD_REQUESTED,
  })
}
